import React from 'react';

const StatusLabel = ({ type, children }) => {
  return (
    <div className={`
      h-fit w-fit box-border rounded-[0.125rem]
      text-black bg-[hsl(206, 23%, 94%)]
      flex flex-row items-center p-2
      ${type === 'default' ? 'opacity-50' : ''}
      ${type === 'negative' ? 'bg-[#f9e7e7] text-[#c01111]' : ''}
      ${type === 'warning' ? 'bg-[#fbf1d5] text-[#e9b225]' : ''}
      ${type === 'positive' ? 'bg-[#dcefd7] text-[#208806]' : ''}
      ${type === 'progress' ? 'bg-[#e6f1ff] text-[#3379db]' : ''}
      ${type === 'orange' ? 'bg-[#fde8d0] text-[#b85c00]' : ''}
      ${type === 'dark-red' ? 'bg-[#f5e0e0] text-[#8b0000]' : ''}
    `}>
      <div className={`
      ${type === 'default' ? 'opacity-50' : ''}
      ${type === 'negative' ? 'text-[#f42b2b]' : ''}
      ${type === 'warning' ? 'text-[#e9b225]' : ''}
      ${type === 'positive' ? 'text-[#208806]' : ''}
      ${type === 'progress' ? 'text-[#3379db]' : ''}
      ${type === 'orange' ? 'text-[#8e4700]' : ''}
      ${type === 'dark-red' ? 'text-[#8b0000]' : ''}
        text-left flex-1`}>{children}</div>
    </div>
  );
};

export default StatusLabel;